import { TableHead, TableHeader, TableRow } from '@/components/ui';
import { TableHeadSortable } from '@/components/custom';
import { IPaymentMethodRequest } from '@/interfaces';
import { nameof } from '@/functions';

export const DataTableHeader = () => (
  <TableHeader>
    <TableRow>
      <TableHead className='w-auto' />
      <TableHead className='w-auto'>
        Utilisateur
      </TableHead>
      <TableHeadSortable
        className='w-auto'
        name={nameof<IPaymentMethodRequest>('country')}
        text='Pays' />
      <TableHead className='w-auto whitespace-nowrap'>
        Moyen de paiement demandé
      </TableHead>
      <TableHeadSortable
        className='w-auto'
        name={nameof<IPaymentMethodRequest>('status')}
        text='Statut' />
      <TableHeadSortable
        className='w-44'
        name={nameof<IPaymentMethodRequest>('createdAt')}
        text='Crée le' />
      <TableHead className='w-12 text-right'>
        Actions
      </TableHead>
    </TableRow>
  </TableHeader>
);

export default DataTableHeader;
